var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908",
    transform: "translate(-269 -679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "police",
    transform: "translate(269.65 678.999)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M15,36h1.858v5.573H15Z",
    transform: "translate(-4.569 -12.565)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M20.648,22h-13a2.789,2.789,0,0,1-2.787-2.787V9H3V19.217a4.65,4.65,0,0,0,4.644,4.644h13a4.59,4.59,0,0,1,1.955.447l-5.671,5.671,1.313,1.313L24.1,25.434a4.607,4.607,0,0,1,1.188,3.072v2.787H27.15V28.506A6.509,6.509,0,0,0,20.648,22Z",
    transform: "translate(0 -2.284)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M29.188,4.894l-6.5-1.858a.93.93,0,0,0-.511,0l-6.5,1.858a.929.929,0,0,0-.646,1.117l.9,3.6V11.36a6.5,6.5,0,0,0,13,0V9.616l.9-3.6A.929.929,0,0,0,29.188,4.894Zm-6.757,0,5.383,1.538-.534,2.14H23.36V6.716H21.5V8.573H17.583l-.535-2.14Zm0,11.109a4.65,4.65,0,0,1-4.644-4.644v-.929h9.288v.929A4.65,4.65,0,0,1,22.431,16Z",
    transform: "translate(-4.569 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 32,
    height: 32,
    transform: "translate(269 679)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/police.1dd53600b5a6e2f53c026aadcee787d5.svg";
export { ForwardRef as ReactComponent };